const menulist = [
    // {
    //     id: 999,
    //     name: '健康监控',
    //     path: '/home',
    //     parentId: 0,
    //     icon: 'el-icon-menu',
    //     enable: 1,
    //     children: [],
    // },
    {
        id: 103,
        name: '数据看板',
        path: '/jsgs/screen',
        parentId: 0,
        icon: 'el-icon-set-up',
        enable: 1,
        children: [],
    },
    
    {
        id: 101,
        name: '学生列表',
        path: '/jsgs/students',
        parentId: 0,
        icon: 'el-icon-user',
        enable: 1,
        children: [],
    },
    {
        id: 102,
        name: '设备管理',
        path: '/jsgs/device',
        parentId: 0,
        icon: 'el-icon-set-up',
        enable: 1,
        children: [],
    },
    {
        id: 1,
        name: '训练任务',
        path: '/jsgs/xunlianrenwu',
        parentId: 0,
        icon: 'el-icon-price-tag',
        enable: 1,
        children: [],
    },
    /* 
    {
        id: 2,
        name: '健康监控',
        path: '/jiankangjiankong',
        parentId: 0,
        icon: 'el-icon-menu',
        enable: 1,
        children: [],
    },
    */
    {
        id: 3,
        name: '跳绳训练',
        path: '',
        parentId: 0,
        icon: 'el-icon-set-up',
        enable: 1,
        children: [
            {
                id: 31,
                name: '跳绳训练',
                path: '/jsgs/tiaoshengxunlian',
                parentId: 3,
                icon: 'el-icon-menu',
                enable: 1,
                children: [],
            },
            {
                id: 32,
                name: '当日训练排名',
                path: '/jsgs/tiaoshengxunlian_dayrank',
                parentId: 3,
                icon: 'el-icon-menu',
                enable: 1,
                children: [],
            },
            {
                id: 33,
                name: '本学期训练排名',
                path: '/jsgs/tiaoshengxunlian_termrank',
                parentId: 3,
                icon: 'el-icon-menu',
                enable: 1,
                children: [],
            }
        ],
    },
    {
        id: 4,
        name: '跳绳比赛',
        path: '',
        parentId: 0,
        icon: 'el-icon-bangzhu',
        enable: 1,
        children: [
            {
                id: 41,
                name: '跳绳比赛',
                path: '/jsgs/tiaoshnegbisai',
                parentId: 4,
                icon: 'el-icon-menu',
                enable: 1,
                children: [],
            },
            {
                id: 42,
                name: '个人比赛排名',
                path: '/jsgs/tiaoshnegbisai_personrank',
                parentId: 4,
                icon: 'el-icon-menu',
                enable: 1,
                children: [],
            },
            {
                id: 43,
                name: '班级比赛排名',
                path: '/jsgs/tiaoshnegbisai_classrank',
                parentId: 4,
                icon: 'el-icon-menu',
                enable: 1,
                children: [],
            },
            {
                id: 44,
                name: '年级比赛排名',
                path: '/jsgs/tiaoshnegbisai_graderank',
                parentId: 4,
                icon: 'el-icon-menu',
                enable: 1,
                children: [],
            },
        ],
    },
    // {
    //     id: 6,
    //     name: '通知',
    //     path: '/tongzhi',
    //     parentId: 0,
    //     icon: 'el-icon-menu',
    //     enable: 1,
    //     children: [],
    // },
    {
        id: 7,
        name: '智能体测',
        path: '/jsgs/zhienngtice',
        parentId: 0,
        icon: 'el-icon-files',
        enable: 1,
        children: [],
    },
    {
        id: 8,
        name: '课表',
        path: '/jsgs/kebiao',
        parentId: 0,
        icon: 'el-icon-notebook-2',
        enable: 1,
        children: [],
    },
    {
        id: 9,
        name: '请假',
        path: '/jsgs/qingjia',
        parentId: 0,
        icon: 'el-icon-document-checked',
        enable: 1,
        children: [],
    },
    {
        id: 10,
        name: '考勤管理',
        path: '/jsgs/kaoqinguanli',
        parentId: 0,
        icon: 'el-icon-date',
        enable: 1,
        children: [],
    },
    {
        id: 104,
        name: '积分管理',
        path: '/jsgs/score',
        parentId: 0,
        icon: 'el-icon-timer',
        enable: 1,
        children: [],
    },
    {
        id: 105,
        name: '线上说明',
        path: '/jsgs/help',
        parentId: 0,
        icon: 'el-icon-s-promotion',
        enable: 1,
        children: [],
    },
]

export default menulist;